import GameStepBase from '../../game_step_base';


export default class BuildExternalGameProviderCssClassNameGameStep extends GameStepBase {
    static CLASS = 'BuildExternalGameProviderCssClassNameGameStep';

    init(params) {
        if(!params.providerName) {
            this.throwArgumentExpected('9', 'init', 'providerName');
        }

        this._providerName = params.providerName;
        this._gameTechnology = params.gameTechnology || 'external';
    }

    run(gameOptions) {
        let newGameOptions = Object.assign(gameOptions, {
            gameProviderCssClassName: `out-house-cgp-provider-${this._providerName}-${this._gameTechnology}`
        });
        return Promise.resolve(newGameOptions)
    }
}